export default __webpack_public_path__ + "static/media/ebrio.63c5c410.png";